export default {
  title: "Mon Compte",
  subtitle: "Gérez votre profil et vos paramètres",
  description: "Gérez les paramètres de votre compte",
  
  profile: {
    title: "Profil",
    completeProfile: "Compléter le profil",
    defaultName: "Invité",
    noProfile: "Aucun profil",
    errors: {
      loadProfile: "Erreur lors du chargement du profil",
      saveProfile: "Erreur lors de la sauvegarde du profil"
    },
    weddingInfo: {
      title: "Informations du mariage",
      partner1: "Partenaire 1",
      partner2: "Partenaire 2",
      date: "Date",
      location: "Lieu",
      expectedGuests: "Invités prévus",
      notes: "Notes"
    }
  },

  settings: {
    title: "Paramètres",
    loadError: "Erreur lors du chargement des paramètres",
    saveError: "Erreur lors de l'enregistrement",
    saveSuccess: "Paramètres enregistrés avec succès"
  },
  security: "Sécurité",
  notifications: "Notifications",
  profilePhoto: "Photo de profil",
  changePhoto: "Changer la photo",
  photoRequirements: "JPG, PNG ou GIF, 2Mo max",
  deletePhoto: "Supprimer la photo",
  saveChanges: "Enregistrer les modifications",
  
  subscription: {
    title: "Abonnement",
    currentPlan: "Plan actuel",
    free: "Gratuit",
    essential: "Essentiel",
    pro: "Pro",
    manage: "Gérer l'abonnement",
    viewPlans: "Voir les plans",
    upgrade: "Passer à la version supérieure",
    eventsUsed: "Événements utilisés",
    limits: {
      maxGuests: "Invités max",
      maxTasks: "Tâches max",
      maxVendors: "Prestataires max",
      maxEvents: "Événements max"
    },
    features: {
      unlimitedEvents: "Événements illimités",
      unlimitedGuests: "Invités illimités",
      export: "Export PDF & Excel",
      budget: "Budget & Analyses",
      seating: "Plan de table",
      support: "Support prioritaire"
    },
    plans: {
      free: { name: "Gratuit" },
      essential: { name: "Essentiel" },
      premium: { name: "Premium" },
      pro: { name: "Pro" }
    }
  },

  limits: {
    title: "Limites",
    maxGuests: "Invités maximum",
    maxTasks: "Tâches maximum",
    maxVendors: "Prestataires maximum",
    maxCollaborators: "Collaborateurs maximum"
  },

  form: {
    firstName: "Prénom",
    lastName: "Nom",
    email: "Email",
    phone: "Téléphone",
    address: "Adresse",
    city: "Ville",
    country: "Pays",
    timezone: "Fuseau horaire",
    language: "Langue",
    avatar: "Avatar"
  },

  actions: {
    save: "Enregistrer",
    cancel: "Annuler",
    edit: "Modifier",
    delete: "Supprimer le compte",
    changePassword: "Changer le mot de passe",
    uploadAvatar: "Téléverser un avatar"
  },

  messages: {
    profileUpdated: "Profil mis à jour avec succès",
    passwordChanged: "Mot de passe changé avec succès",
    avatarUploaded: "Avatar téléversé avec succès",
    accountDeleted: "Compte supprimé avec succès",
    error: "Une erreur est survenue"
  },

  events: {
    yourEvents: "Vos événements"
  },

  partners: {
    title: "Informations des partenaires",
    partner1: "Partenaire 1",
    partner2: "Partenaire 2",
    firstName: "Prénom",
    lastName: "Nom",
    email: "Email",
    save: "Enregistrer"
  },
  
  pageTitle: "Compte | WedBox",
  accountManagement: "Gestion du compte",
  chooseWhatToManage: "Choisissez ce que vous souhaitez gérer",
  myProfile: "Mon Profil",
  personalPreferences: "Préférences personnelles",
  managePersonalInfo: "Gérez vos informations personnelles, photo de profil, langue et préférences de notification.",
  accessMyProfile: "Accéder à mon profil",
  eventSettings: "Paramètres d'événement",
  
  eventTypeSpecific: {
    wedding: {
      subtitle: "Spécifique à votre mariage",
      description: "Gérez les détails de votre mariage, partenaires, date, collaborateurs et statistiques.",
      buttonText: "Paramètres du mariage"
    },
    birthday: {
      subtitle: "Spécifique à votre anniversaire", 
      description: "Gérez les détails de votre anniversaire, date, collaborateurs et statistiques.",
      buttonText: "Paramètres de l'anniversaire"
    },
    "baby-shower": {
      subtitle: "Spécifique à votre baby shower",
      description: "Gérez les détails de votre baby shower, date, collaborateurs et statistiques.",
      buttonText: "Paramètres du baby shower"
    },
    baptism: {
      subtitle: "Spécifique à votre baptême",
      description: "Gérez les détails de votre baptême, date, collaborateurs et statistiques.",
      buttonText: "Paramètres du baptême"
    },
    engagement: {
      subtitle: "Spécifique à vos fiançailles",
      description: "Gérez les détails de vos fiançailles, date, collaborateurs et statistiques.",
      buttonText: "Paramètres des fiançailles"
    },
    default: {
      subtitle: "Spécifique à votre événement",
      description: "Gérez les détails de votre événement, date, collaborateurs et statistiques.",
      buttonText: "Paramètres de l'événement"
    }
  },
  improvedOrganization: "📋 Organisation améliorée",
  organizationNote: "Nous avons séparé les paramètres personnels des paramètres spécifiques aux événements pour une meilleure organisation. Vos préférences utilisateur sont maintenant dans \"Mon Profil\", tandis que tout ce qui concerne votre événement se trouve dans \"Paramètres d'événement\".",
  
  subscriptionManagement: "Gestion de l'abonnement",
  manageYourPlan: "Gérez votre plan et suivez votre utilisation",
  
  displayName: "Nom d'affichage",
  phoneNumber: "Numéro de téléphone",
  yourFullName: "Votre nom complet",
  emailAddress: "Adresse email",
  emailCannotBeModified: "L'email ne peut pas être modifié pour des raisons de sécurité",
  personalInformation: "Informations personnelles",
  languageInterface: "Langue de l'interface",
  notificationPreferences: "Préférences de notification",
  emailNotifications: "Notifications par email",
  receiveEmailNotifications: "Recevoir des notifications par email",
  pushNotifications: "Notifications push",
  receiveBrowserNotifications: "Recevoir des notifications dans le navigateur",
  deleteAccountWarning: "⚠️ Cette action est irréversible. Toutes vos données seront définitivement supprimées.",
  permanentlyDeleteAccount: "Supprimer définitivement mon compte",
  languageChangedTo: "Langue changée en {{language}}",
  error: "Erreur :",
  saveError: "Vous pouvez ajouter une notification d'erreur ici",

  language: "Langue",
  languageDescription: "Choisissez la langue d'affichage de l'application",
  languageSelect: "Sélectionnez votre langue",
  weddingDetails: "Détails du mariage",
  weddingDate: "Date du mariage",
  partnerInfo: "Informations des partenaires",
  partner1: "Partenaire 1",
  partner2: "Partenaire 2",
  firstName: "Prénom",
  lastName: "Nom",
  accessManagement: "Gestion des accès",
  accessManagementDescription: "Gérez qui peut accéder à vos données de mariage",
  manageCollaborators: "Gérer les collaborateurs",
  loadError: "Erreur lors du chargement des paramètres",
  saveSuccess: "Paramètres enregistrés avec succès",
  noData: "Aucune donnée disponible",
  
  tabs: {
    profile: "Profil",
    sharing: "Partage",
    settings: "Paramètres"
  },

  delete: {
    title: "Supprimer le compte",
    description: "Supprimer définitivement votre compte et toutes les données associées",
    confirmTitle: "Êtes-vous sûr ?",
    confirmDescription: "Cette action est irréversible. Toutes vos données seront définitivement supprimées.",
    confirmButton: "Supprimer le compte",
    gdprNotice: "Conformément au RGPD, toutes vos données personnelles seront définitivement supprimées."
  },

  deleteAccount: {
      title: "Supprimer le compte",
      description: "Supprimer définitivement votre compte et toutes les données associées",
      warning: "Cette action est irréversible",
      confirm: "Confirmer la suppression",
      confirmDescription: "Veuillez confirmer votre mot de passe pour continuer",
      confirmFacebookDescription: "Veuillez confirmer avec Facebook pour continuer",
      confirmGoogleDescription: "Veuillez confirmer avec Google pour continuer",
      passwordLabel: "Mot de passe",
      reasonLabel: "Raison de la suppression",
      feedbackLabel: "Feedback (optionnel)",
      errors: {
        authCancelled: "Authentification annulée",
        generic: "Une erreur est survenue",
        recentLogin: "Veuillez vous reconnecter pour effectuer cette action",
        wrongPassword: "Mot de passe incorrect",
        invalidPassword: "Mot de passe invalide",
        popupClosed: "La fenêtre a été fermée",
        reasonRequired: "La raison est requise"
      },
      success: "Compte supprimé avec succès",
      reasons: {
        select: "Sélectionnez une raison",
        foundAlternative: "J'ai trouvé une alternative",
        tooComplex: "Trop complexe",
        notUseful: "Pas utile pour moi",
        other: "Autre"
      }
  },

  export: {
    title: "Exporter les données",
    description: "Téléchargez toutes vos données au format JSON",
    button: "Télécharger les données",
    loading: "Préparation du téléchargement...",
    gdprNotice: "Cet export inclut toutes vos données personnelles conformément aux exigences du RGPD."
  },

  errors: {
    deleteAccount: "Erreur lors de la suppression du compte",
    exportData: "Erreur lors de l'exportation des données"
  },
  
  sharing: {
    activeLinksTitle: "Liens de Partage Actifs",
    activeLinksDesc: "Ces liens permettent l'accès à votre événement sans compte utilisateur.",
    accessTo: "Accès à"
  },

  collaborators: {
    title: "Collaborateurs",
    description: "Gérez les personnes qui peuvent vous aider dans l'organisation de votre mariage",
    count: "{{count}} collaborateurs",
    invite: "Inviter un collaborateur",
    inviteEmail: "Adresse email",
    placeholder: "Entrez l'adresse email",
    role: "Rôle",
    roles: {
      admin: "Administrateur",
      editor: "Éditeur",
      viewer: "Lecteur"
    },
    roleDescriptions: {
      admin: "Peut tout modifier et gérer les collaborateurs",
      editor: "Peut modifier les sections sélectionnées",
      viewer: "Peut uniquement voir les sections sélectionnées"
    },
    rolesTitle: "Gestion des rôles",
    accessTo: "Accès à",
    accessToSections: "Accès aux sections",
    resourceTypes: {
      all: "Tout",
      tasks: "Tâches",
      guests: "Invités",
      budget: "Budget",
      timeline: "Chronologie",
      tasks_and_guests: "Tâches et Invités"
    },
    status: {
      pending: "En attente",
      accepted: "Accepté",
      refused: "Refusé",
      expired: "Expiré"
    },
    lastActive: "Dernière activité",
    remove: "Supprimer le collaborateur",
    modifyAccess: "Modifier l'accès",
    updateRoleError: "Erreur lors de la mise à jour du rôle",
    inviteSuccess: "Invitation envoyée avec succès",
    inviteError: "Erreur lors de l'envoi de l'invitation",
    list: "Liste des collaborateurs",
    empty: "Pas encore de collaborateurs"
  }
};
